<template>
  <div>
    <my-asidebar v-bind:active-tab="'settings'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Ayarlar</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/settings'" class="text-white">Ayarlar</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-main-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <form id="portForm">
                  <div class="form-box">
                    <div class="form-content pb-2">
                      <h3 class="title mb-3">Ayarlar</h3>
                      <div class="row justify-content-between">
                        <div class="btn-box">
                          <button :class="{'disabled' : false}" style="color: white" @click="invalidateCaches" class="theme-btn" type="button">Web cachelerini sıfırla</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="row" v-if="systemSettingMap['early_booking_settings_enabled'].value">
              <div class="col-lg-12">
                <form id="earlyBookingSettingsForm">
                  <div class="form-box">
                    <div class="form-content pb-2">
                      <h3 class="title mb-3">Erken Rezervasyon Ayarları</h3>
                      <div class="row justify-content-end">
                        <div class="input-box">
                          <button :class="{'disabled' : false}" style="color: white" @click="saveEarlyBookingChanges" class="theme-btn" type="button">Erken Rezervasyon Ayarlarını Kaydet</button>
                        </div>
                      </div>
                      <div class="row justify-content">
                        <div class="input-box">
                          <label class="label-text">Early Rezervasyon End Date</label>
                          <input class="form-control" v-model="systemSettingMap['early_booking_end_date'].value" id="earlyDiscountEndDate" type="date" placeholder="">
                        </div>
                      </div>
                      <div class="row justify-content">
                        <div class="input-box">
                          <label class="label-text">Erken Rezervasyon İndirimi ( % )</label>
                          <input class="form-control" v-model="systemSettingMap['early_booking_default_discount'].value" id="defaultEarlyDiscountPercentage" type="number" min="0" max="90" placeholder="">
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="row" v-if="systemSettingMap['payment_settings_enabled'].value">
              <div class="col-lg-12">
                <form id="paymentSettings">
                  <div class="form-box">
                    <div class="form-content pb-2">
                      <h3 class="title mb-3">Ödeme Ayarları</h3>
                      <div class="row justify-content-end">
                        <div class="input-box">
                          <button :class="{'disabled' : false}" style="color: white" @click="savePaymentChanges" class="theme-btn" type="button">Ödeme Ayarlarını Kaydet</button>
                        </div>
                      </div>
                      <div class="row justify-content">
                        <base-select-input v-model="systemSettingMap['payment_exchange_method'].value"
                                           :label="'Ödeme Kur Methodu'"
                                           :rules="'required'"
                                           :option-list="[{'id' : 'fixed', 'name' : 'Fix Kur'}, {'id' : 'tcmb', 'name' : 'TCMB Efektif Satış'}]">
                        </base-select-input>
                      </div>
                      <div class="row justify-content" v-if="systemSettingMap['payment_exchange_method'].value === 'fixed'">
                        <div class="input-box">
                          <label class="label-text">Fix TL / EUR Kuru</label>
                          <input class="form-control" v-model="systemSettingMap['manual_exchange_rate'].value" id="manualExchangeRate" type="number" min="0" max="90" placeholder="">
                        </div>
                      </div>
                      <div class="row justify-content" v-if="systemSettingMap['payment_exchange_method'].value === 'tcmb'">
                        <div class="input-box">
                          <label class="label-text">Extra Kur Farkı %</label>
                          <label class="label-text">( {{(tcmbExchangeRate / 100 * (100 + parseFloat(systemSettingMap['payment_exchange_rate_margin_percent'].value))) | toCurrency}} )</label>
                          <input class="form-control" v-model="systemSettingMap['payment_exchange_rate_margin_percent'].value" id="marginRate" type="number" min="0" max="90" placeholder="">
                        </div>
                      </div>
                      <div class="row justify-content mb-2 mt-4">
                        <div class="input-box">
                          <a @click="showExchangeRateHistoryPopup" href="#">Kur geçmişini görüntüle</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <exchange-rate-history-popup/>
    </section>

  </div>
</template>

<script>
import PortDetail from "../component/port/PortDetail";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
import messagePopupManager from "../util/messagePopupManager";
import BaseSelectInput from "../component/base/BaseSelectInput";
import ExchangeRateHistoryPopup from "../component/booking/ExchangeRateHistoryPopup";

export default {
  name: "SettingsPage",
  components: {ExchangeRateHistoryPopup, BaseSelectInput, TopBar, MyAsidebar,  PortDetail},
  data:function (){
    return{
      tcmbExchangeRate : 0
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    systemSettingMap:{
      get(){
        let systemSettings = this.$store.getters.getSystemSettingList;



        if(!systemSettings) return null;
        let systemSettingsMap = systemSettings.reduce(function (map,systemSetting){
          map[systemSetting.name] = systemSetting
          return map
        },{})

        systemSettingsMap["pricing_period_enabled"].value =
            systemSettingsMap["pricing_period_enabled"].value === "false" ? false : systemSettingsMap["pricing_period_enabled"].value;

        systemSettingsMap["payment_settings_enabled"].value =
            systemSettingsMap["payment_settings_enabled"].value === "false" ? false : systemSettingsMap["payment_settings_enabled"].value;

        systemSettingsMap["early_booking_settings_enabled"].value =
            systemSettingsMap["early_booking_settings_enabled"].value === "false" ? false : systemSettingsMap["early_booking_settings_enabled"].value;

        return systemSettingsMap;
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_SETTINGS"]) this.$router.push("/");
    this.$store.dispatch("loadSystemSettingList");

    this.$store.dispatch("loadExchangeRate").then((response) => {
      this.tcmbExchangeRate = response.eur;
    })
  },
  methods: {
    showExchangeRateHistoryPopup(){
      $("#exchangeRateHistoryPopup").modal("show");
    },
    invalidateCaches() {
      this.$store.dispatch("invalidateCaches").then(response => {
        messagePopupManager.showSuccess();
      })
    },
    saveEarlyBookingChanges() {
      this.$store.dispatch("updateSystemSetting",this.systemSettingMap["early_booking_default_discount"]).then(response => {
        this.$store.dispatch("updateSystemSetting",this.systemSettingMap["early_booking_end_date"]).then(response => {
          messagePopupManager.showSuccess();
        })
      })
    },
    savePaymentChanges() {
      this.$store.dispatch("updateSystemSetting",this.systemSettingMap["payment_exchange_rate_margin_percent"]).then(response => {
        this.$store.dispatch("updateSystemSetting",this.systemSettingMap["payment_exchange_method"]).then(response => {
          this.$store.dispatch("updateSystemSetting",this.systemSettingMap["manual_exchange_rate"]).then(response => {
            messagePopupManager.showSuccess();
          })
        })
      })
    }
  }
}
</script>

<style scoped>

</style>